import View from '../../../View'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import {isPanelOpened, isNeedToLoadData, isLoading} from './selectors'
import PanelContainer from "../../../components/PanelContainer";
import EditUserPanelContainer from "./EditUserPanelContainer";
import {closeEditUserPanel, loadEditUserPanelData} from "./actions";
import LoadingContainer from "../../../util/LoadingContainer";
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from "../../constants";

class EditUserPanel extends View {
    constructor({
        onPanelHide = () => {},
        loadEditUserPanelData = () => {},
    }) {
        super()

        this.onPanelHide = onPanelHide
        this.loadEditUserPanelData = loadEditUserPanelData

        this.state = {
            show: false,
            loading: false,
            needToLoadData: true,
        }

        this.onStatePropertyChanged('loading', loading => this.loadingWrapper.setState({loading}))

        this.onStatePropertyChanged('show', show => {
            this.wrapper.setState({isShown: show})
        })

        this.onStatePropertyChanged('needToLoadData', (needToLoadData, prevNeedToLoadData) => {
            if (needToLoadData !== prevNeedToLoadData && needToLoadData === true) {
                this.loadEditUserPanelData()
            }
        })
    }

    afterRender() {
        this.loadingWrapper = new LoadingContainer({
            contentComponent: new EditUserPanelContainer(),
            containerClass: 'userPanelLoadingWrapper',
            loadingMoireConfig: {delay: 500}
        })

        this.wrapper = new PanelContainer({
            component: this.loadingWrapper,
            additionalClass: "edit_user_sliding_panel sliding_panel",
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            showHideButton: true,
            hideOnEsc: true,
            hideOnClickOutside: {
                hideOnClick: true,
                panelType: PANEL_TYPES.EDIT_USER,
            },
            onHideCallback: () => this.onPanelHide(),
            hideHandler: () => this.wrapper.setState({isShown: false}),
            onClickCloseButton: () => this.onPanelHide(),
        }).init(this.$containerEl)
    }
}

export default connect(
    state => ({
        needToLoadData: isNeedToLoadData(state),
        show: isPanelOpened(state),
        loading: isLoading(state)
    }),
    dispatch => ({
        onPanelHide: bindActionCreators(closeEditUserPanel, dispatch),
        loadEditUserPanelData: bindActionCreators(loadEditUserPanelData, dispatch),
    })
)(EditUserPanel)



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/EditUserPanel.js